import request from "@/plugins/request"

// 获取收藏列表
export const getFavoriteList = (params) => {
  return request({
    url: "app-api/product/favorite/page",
    method: "get",
    params,
  })
}

// 添加收藏
export const addFavorite = (data) => {
  return request({
    url: "app-api/product/favorite/create",
    method: "post",
    data,
  })
}

// 取消收藏
export const removeFavorite = (params) => {
  return request({
    url: "app-api/product/favorite/delete",
    method: "delete",
    data: params,
  })
}
